import React from 'react';

export default (props) => {
    return <div className="credits inset-text">
        <div className="credits-subtitle">Produced by</div>
        <div className="credits-names">Marc Lajoie</div>
        <div className="credits-subtitle">With input from</div>
        <div className="credits-names">D J Clark, Claudia Hinterseer, Andrea Deng, Peter Carney, Frentee Ji, Timothy Chui and Peter Lin</div>
    </div>
}


// WEBPACK FOOTER //
// ./src/js/components/special/Credits/Credits.jsx